import { render } from "./DiscussionInteractive.vue?vue&type=template&id=2264ea78&scoped=true"
import script from "./DiscussionInteractive.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionInteractive.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionInteractive.vue?vue&type=style&index=0&id=2264ea78&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2264ea78"]])

export default __exports__